import { TextField, withStyles } from "@material-ui/core";
export const CustomTextField = withStyles((theme) => ({
  root: {
    width: "100%",
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset": {
        borderColor: "#4f2d7f", // border color on hover
      },
      "&.Mui-focused fieldset": {
        borderColor: "#4f2d7f", // border color on focus
      },
    },
  },
}))(TextField);
